import {createSlice} from "@reduxjs/toolkit";
import {getPrivacyPolicy} from "./privacyPolicyFetch";

const initialState = {
    isLoading:false,
    error:'',
    policyList: [],

}
const PrivacyPolicySlice = createSlice({
    name: 'brands',
    initialState,
    reducers:{},
    extraReducers:{
        [getPrivacyPolicy.pending.type]: (state) => {
            state.isLoading = true
        },
        [getPrivacyPolicy.fulfilled.type]:(state, action)=>{
            state.isLoading = false
            state.error = ''
            state.policyList = action.payload
        },
        [getPrivacyPolicy.rejected.type]:(state, action)=>{
            state.isLoading = false
            state.error = action.payload
        },

    }
})
export const {} = PrivacyPolicySlice.actions

export default PrivacyPolicySlice.reducer
